import axios from 'axios'

let Faq:any = {};

Faq.GetListeFaq = async ()=>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/webfaq`);
}

export default Faq;